Number.prototype.before = function () {
  var value = parseInt(this.toString().split(".")[0], 10);//before
  return value ? value : 0;
}

Number.prototype.after = function () {
  var value = parseInt(this.toFixed(2).toString().split(".")[1], 10);//after
  return value ? value : 0;
}

export function numberToReal(value, prefixo = true) {
  if (value === undefined || value === null || isNaN(value)) value = 0;

  const options = {
    style: "currency",
    currency: "BRL",
    minimumFractionDigits: 2,
  };

  const formatter = new Intl.NumberFormat("pt-BR", options);
  const formatted = formatter.format(value);

  return prefixo ? formatted : formatted.replace("R$ ", "");
}

export function numberToRealWitoutSymbol(value) {
  if (value === undefined || value === null || isNaN(value)) value = 0;

  const formatter = new Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency: "BRL",
    minimumFractionDigits: 2,
  });

  // Remove o símbolo "R$" e o espaço após ele
  return formatter.format(value).replace(/^R\$\s?/, "");
}

export function numberToDollar(value) {
  if (value === undefined || value === null || isNaN(value)) value = 0;

  const formatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 2,
  });

  return formatter.format(value); // ex: $1,234.56
}


export function numberWithK(value) {
  if (isNaN(value)) return 'NaN';
  if (Math.abs(value) < 1000) return value.toString();

  const suffixes = ['', 'K', 'M', 'B', 'T'];
  const tier = Math.floor(Math.log10(Math.abs(value)) / 3);
  const suffix = suffixes[tier];
  const scaledNum = value / Math.pow(1000, tier);

  const formatter = new Intl.NumberFormat("en-US", {
    minimumFractionDigits: 1,
    maximumFractionDigits: 1,
  });

  return formatter.format(scaledNum) + suffix;
}
